import { CacheStrategy, PersistRules } from 'DataBase/rtk-persist/types'
import Consts from 'Utils/Consts'

const EXPIRE_TIME = Consts.env.REACT_APP_COMMON_CACHE_EXPIRE_TIME_IN_SECONDS * 1000

export const NOTIF_DB_STORE = 'notification-db'
export const NOTIF_CACHE_STORE = 'queries'
export const NOTIF_CACHE_VERSION = 1

export const persistRules: PersistRules = {
  GetUserNotificationPagedFilterDIP: {
    ttl: EXPIRE_TIME,
    strategy: CacheStrategy.StaleWhileRevalidate,
  },
}
